import type { ILink } from "src/interfaces";
import { titlecaseSentence } from "src/utils";
/**
 * Collects and formats breadcrumb links based on provided paths and parameters.
 *
 * @param providedLinks - An array of objects containing:
 *   - `pathname`: The path of the link.
 *   - `params`: An object with key-value pairs representing route parameters.
 * @returns An array of `ILink` objects representing the breadcrumb links.
 */
export const collectLinks = (
  providedLinks: Array<{ pathname: string; params: { [key: string]: string } }>,
) => {
  const temp: ILink[] = [{ title: "Home", href: "/home" }];
  providedLinks.forEach(match => {
    if (match.pathname !== "/") {
      const segments = match.pathname.split("/");
      const paramValues = Object.values(match.params);
      let title =
        segments.filter(seg => !paramValues.includes(seg)).reverse()[0] ?? "";
      title = titlecaseSentence(title.replaceAll("-", " "));
      title = title.replace("Gmdss", "GMDSS");
      title = title.replace("Nmea", "NMEA");

      if (title && match.pathname) temp.push({ title, href: match.pathname });
    }
  });
  return temp;
};

export const applyCustomLastLinks = (
  links: ILink[],
  customLastLinks: ILink[],
) => {
  if (!customLastLinks.length) return links;
  const updatedLinks = [...links];
  updatedLinks.pop();
  updatedLinks.push(...customLastLinks);
  return updatedLinks;
};
